module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/75/assets/images/2fd404242359a7af6937872c52e1d9a2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_unassignall.svg
// module id = xUnp
// module chunks = 0